var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorViewUnsubscribed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74.802,
    height: 70.995,
    viewBox: "0 0 74.802 70.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:url(#b);}.c{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.036,
    y1: 0.618,
    x2: 0.406,
    y2: 0.447,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#ff8066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8066"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.615,
    y1: -0.238,
    x2: 0.263,
    y2: 1.643,
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-124.044 -224.418)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 70.995,
    height: 70.995,
    rx: 10,
    transform: "translate(127.851 224.418)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 70.995,
    height: 70.995,
    rx: 12,
    transform: "translate(124.044 224.418)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M19.794-.562,2.923-29.813a3.377,3.377,0,0,0-5.847,0L-19.795-.562A3.377,3.377,0,0,0-16.871,4.5H16.871A3.377,3.377,0,0,0,19.794-.562ZM0-6.609A3.234,3.234,0,0,1,3.234-3.375,3.234,3.234,0,0,1,0-.141,3.234,3.234,0,0,1-3.234-3.375,3.234,3.234,0,0,1,0-6.609ZM-3.071-18.235a.844.844,0,0,1,.842-.89H2.228a.844.844,0,0,1,.842.89L2.549-8.673a.844.844,0,0,1-.842.8H-1.707a.844.844,0,0,1-.842-.8Z",
    transform: "translate(161.73 273.09)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorViewUnsubscribed);
export default __webpack_public_path__ + "static/media/error_view_unsubscribed.2e6d4a2ef2843428ee908feb2a976ae2.svg";
export { ForwardRef as ReactComponent };